import React from 'react';
import classNames from 'classnames';
import { Typography } from '../typography/typography';
import { useAccentBgContext } from '../accent-bg-context/accent-bg-context';
import Circle from './assets/circle.svg?react';
import CircleFilled from './assets/circle-filled.svg?react';
import styles from './tag.module.scss';

type Props = {
  filled?: boolean;
  children: string;
};

export const Tag: React.FC<Props> = ({ children, filled = false }) => {
  const { isAccentBackground } = useAccentBgContext();

  return (
    <span className={styles.root}>
      {filled ? (
        <CircleFilled className={styles.icon} />
      ) : (
        <Circle className={classNames(styles.icon, styles.empty, { [styles.accent]: isAccentBackground })} />
      )}
      <Typography color={isAccentBackground ? 'white' : 'black'} tag="span" variant="smalltext">
        {children}
      </Typography>
    </span>
  );
};
